import '../filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.ModeratorFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  name: 'moderator'
  facetName: 'last_moderator'
  humanize: true
  selectAll: true

  getAppliedValues: ->
    return @searchQuery.get('moderators')

  addFilter: (value) ->
    @searchQuery.addModerator(value)

